import { api, apiCall } from './client'
import type {
  Patient,
  CreatePatientData,
  ApiResponse,
  InsData,
  InsStatut,
  PaginatedData,
} from '../../types'

export interface InsStatusResponse {
  statut: InsStatut
  insMatricule?: string
  insOid?: string
}

export const patientsService = {
  // Récupérer les patients avec pagination/filtres
  async list(params?: {
    page?: number
    limit?: number
    search?: string
    sortBy?: string
    sortOrder?: 'ASC' | 'DESC'
  }): Promise<ApiResponse<PaginatedData<Patient>>> {
    return apiCall(api.get<ApiResponse<PaginatedData<Patient>>>('/patients', { params }))
  },

  // Récupérer tous les patients (compat)
  async getAll(): Promise<ApiResponse<Patient[]>> {
    return apiCall(api.get<ApiResponse<Patient[]>>('/patients'))
  },

  // Récupérer un patient par ID
  async getById(id: number): Promise<ApiResponse<Patient>> {
    return apiCall(api.get<ApiResponse<Patient>>(`/patients/${id}`))
  },

  // Créer un nouveau patient
  async create(patientData: CreatePatientData): Promise<ApiResponse<Patient>> {
    return apiCall(api.post<ApiResponse<Patient>>('/patients', patientData))
  },

  // Mettre à jour un patient
  async update(
    id: number,
    patientData: Partial<CreatePatientData>
  ): Promise<ApiResponse<Patient>> {
    return apiCall(api.put<ApiResponse<Patient>>(`/patients/${id}`, patientData))
  },

  // Supprimer un patient
  async delete(id: number): Promise<ApiResponse<void>> {
    return apiCall(api.delete<ApiResponse<void>>(`/patients/${id}`))
  },

  // Rechercher des patients
  async search(query: string): Promise<ApiResponse<Patient[]>> {
    return apiCall(
      api.get<ApiResponse<Patient[]>>(`/patients/search?q=${encodeURIComponent(query)}`)
    )
  },

  // INS - Obtenir le statut INS d'un patient
  async getInsStatus(id: number): Promise<ApiResponse<InsStatusResponse>> {
    return apiCall(api.get<ApiResponse<InsStatusResponse>>(`/patients/${id}/ins`))
  },

  // INS - Qualifier l'identité d'un patient
  async qualifyIns(id: number, data: InsData): Promise<ApiResponse<Patient>> {
    return apiCall(api.post<ApiResponse<Patient>>(`/patients/${id}/ins/qualify`, data))
  },

  // INS - Invalider l'INS d'un patient
  async invalidateIns(id: number): Promise<ApiResponse<Patient>> {
    return apiCall(api.post<ApiResponse<Patient>>(`/patients/${id}/ins/invalidate`, {}))
  },
}
